<template>
  <div class="markdown-body">
    <p>
      <strong>FAQ</strong>
    </p>
    <p>
      <strong>Apa itu FlashPay?</strong>
    </p>
    <p>FlashPay adalah layanan pembayaran elektronik dalam bentuk e-money yang memungkinkan Pengguna Indonesia untuk dapat dengan mudah melakukan top-up saldo, transfer dana, dan melakukan pembayaran kepada mitra usaha melalui Mobile-Page (web based pada ponsel)  FlashPay milik masing-masing Pengguna.</p>
    <p>
      <strong>Apakah kegunaan FlashPay?</strong>
    </p>
    <p>Saat ini kami mendukung isi ulang, transfer/pembayaran, dan penarikan. Di masa mendatang, kami akan menyediakan skenario pembayaran lainnya untuk memenuhi kebutuhan konsumsi Pengguna.</p>
    <p>
      <strong>Apakah Saya memenuhi syarat untuk menggunakan FlashPay?</strong>
    </p>
    <p>Pengguna minimal berusia 21 tahun dan memiliki identitas Kartu Tanda Penduduk (KTP). Harap membaca Syarat dan Ketentuan Pengguna FlashPay secara lebih lanjut untuk penjelasan lebih lengkap.</p>
    <p>
      <strong>Bagaimana cara Saya untuk mendaftar Akun FlashPay?</strong>
    </p>
    <p>Pendaftar Akun FlashPay hanya diperuntukkan bagi pengguna individu, di mana setiap individu hanya dapat mendaftar 1 (satu) akun, dan mengisi informasi dan data pribadi sebagaimana dipersyaratkan dalam proses registrasi. </p>
    <p>Proses dan persyaratan pendaftaran Pengguna dapat dibaca lebih lengkap pada Syarat dan Ketentuan Pengguna FlashPay.</p>
    <p>
      <strong>Cara pendaftaran akun FlashPay adalah sebagai berikut:</strong>
    </p>
    <ol>
      <li>Siapkan ponsel anda. Tidak ada batasan pada merek, jenis, sistem operasi, penyedia layanan komunikasi. </li>
      <li>Pastikan ponsel anda terhubung dengan jaringan internet. Jaringan internet tersebut dapat berupa jaringan internet yang disediakan oleh layanan komunikasi selular maupun jaringan WiFi sesuai dengan lokasi anda berada.</li>
      <li>Masukan nomor telepon selular (telepon) anda yang terdaftar sesuai dengan peraturan yang ada di Indonesia dan aktif. </li>
      <li>Setelah masukan nomor telepon anda, mohon untuk membaca Terms &amp; Conditions dan Privacy Policy. Anda tidak dapat melakukan aktivitas selanjutnya sebelum membaca Terms &amp; Conditions dan Privacy Policy serta “centang” pada kotak yang telah kami sediakan. </li>
      <li>Setelah membaca Terms &amp; Conditions dan Privacy Policy serta centang sebagai konfirmasi, maka pilih “Kirim Kode”. </li>
      <li>Kami akan mengirim pesan OTP melalui WhatsApp. Pastikan telepon selular anda telah memiliki aplikasi WhatsApp dan aktif terhubung dengan nomor telepon yang anda gunakan. OTP akan kami kirim setiap saat anda melakukan login ke FlashPay. OTP yang kami kirim hanya berlaku dalam jangka waktu 5 menit dan hanya berlaku 1 (satu) kali pakai. </li>
      <li>Setelah menerima OTP pada aplikasi WhatsApp anda, maka masukan nomor OTP tersebut. </li>
      <li>Anda berhasil melakukan login ke FlashPay </li>
      <li>Jika anda belum melakukan aktivasi, maka FlashPay tidak dapat digunakan untuk melakukan transaksi (Top-Up, transfer, dan penarikan)</li>
      <li>Anda harus melakukan aktivasi sesuai dengan pop-up yang terdapat pada layar ponsel anda. </li>
      <li>Pilih/ klik “aktivasi”. </li>
      <li>Siapkan KTP anda, lalu foto KTP anda melalui telepon anda layar yang sudah kami tampilkan</li>
      <li>Setelah KTP berhasil di foto dan diterima oleh kami, maka pada layar anda akan muncul hasil informasi sesuai dengan informasi pada KTP anda. </li>
      <li>Cek kembali informasi pada layar dengan keadaan dan informasi sesuai dengan keadaan yang sebenarnya. </li>
      <li>Lanjut pada tahap selanjutnya, anda akan diminta untuk melakukan selfie menggunakan telepon anda sesuai dengan instruksi yang diberikan oleh FlashPay. Mohon untuk tidak menggunakan masker, penutup wajah, topi, serta benda lainnya mengganggu penangkapan kamera terhadap wajah anda. Mohon untuk dilakukan selfie pada tempat yang memiliki intensitas cahaya yang cukup sehingga wajah anda dapat tertangkap oleh kamera dengan jelas. FlashPay akan secara langsung dan otomatis menangkap wajah anda menggunakan kamera depan ponsel anda. </li>
      <li>Setelah berhasil melakukan selfie sebagai bentuk verifikasi identitas anda, maka tahap selanjut nya adalah memasukan password yang digunakan pada setiap transaksi yang akan anda lakukan menggunakan FlashPay. </li>
      <li>Password yang didaftarkan adalah berupa numerik, dan tidak bisa berupa alogaritma 111111, 123456, atau tanggal lahir anda. </li>
      <li>Mohon untuk mengingat password yang anda daftarkan, jika dikemudian hari anda lupa pada password yang telah anda daftarkan, makan klik “lupa password” dan ikuti tahap selanjutnya untuk melakukan pendaftaran password kembali. </li>
      <li>Setelah password berhasil didaftarkan, maka anda telah berhasil melakukan registrasi FlashPay dan FlashPay telah dapat digunakan untuk melakukan transaksi.</li>
    </ol>
    <p>
      <strong>Apakah ada biaya untuk mendaftar FlashPay?</strong>
    </p>
    <p>Pendaftaran FlashPay tidak dikenakan biaya.</p>
    <p>
      <strong>Jika Saya tidak memiliki KTP, apakah Saya dapat mendaftar FlashPay?</strong>
    </p>
    <p>FlashPay hanya dapat digunakan untuk Warga Negara Indonesia yang telah memiliki KTP.</p>
    <p>
      <strong>Apakah Saya dapat memiliki beberapa akun FlashPay?</strong>
    </p>
    <p>Pengguna hanya dapat memiliki 1 akun FlashPay untuk setiap 1 (satu) KTP.</p>
    <p>
      <strong>Bagaimana cara Saya menghubungi FlashPay?</strong>
    </p>
    <p>
      Silahkan hubungi kami di:
      Telp        : +6221-5723257
      E-mail    :
      <a href="mailto:&#99;&#x73;&#x2d;&#112;&#97;&#121;&#x2d;&#105;&#100;&#x40;&#x66;&#108;&#97;&#x73;&#104;&#x66;&#105;&#110;&#x2e;&#99;&#111;&#109;">&#99;&#x73;&#x2d;&#112;&#97;&#121;&#x2d;&#105;&#100;&#x40;&#x66;&#108;&#97;&#x73;&#104;&#x66;&#105;&#110;&#x2e;&#99;&#111;&#109;</a>
    </p>
    <p>
      <strong>Jam kerja Layanan Pelanggan?</strong>
    </p>
    <p>
      Layanan Pelanggan kami aktif pada:
      Hari kerja    :Senin - Jumat
      Jam kerja    :09.00 WIB - 21.00 WIB
    </p>
    <p>
      <strong>Apakah Saya dapat mengubah informasi pribadi?</strong>
    </p>
    <p>Silakan hubungi Layanan Pelanggan FlashPay untuk perubahan informasi pribadi.</p>
    <p>
      <strong>Bagaimana jika Saya ingin melakukan perubahan nomor telepon?</strong>
    </p>
    <p>Jika Anda ingin melakukan perubahan nomor telepon, Anda perlu menghubungi Layanan Pelanggan untuk melakukan verifikasi dan menyelesaikan permohonan Anda.</p>
    <p>
      <strong>Apakah mungkin untuk bertransaksi menggunakan beberapa perangkat dengan menggunakan akun yang sama?</strong>
    </p>
    <p>Setiap akun hanya dapat bertransaksi melalui satu perangkat.</p>
    <p>
      <strong>Akun saya terkunci setelah memasukkan kata sandi yang salah, bagaimana cara membuka kunci tersebut?</strong>
    </p>
    <p>Sistem akan otomatis terbuka setelah 24 jam</p>
    <p>
      <strong>Bagaimana cara mengubah kata sandi Anda？</strong>
    </p>
    <ol>
      <li>Klik “Me”</li>
      <li>Buka “Payment Settings” lalu pilih “Payment Password”</li>
      <li>Masukkan kata sandi Anda saat ini</li>
      <li>Masukkan kata sandi baru Anda</li>
    </ol>
    <p>
      <strong>Apakah ada biaya transaksi？</strong>
    </p>
    <p>Untuk saat ini, FlashPay tidak mengenakan biaya apapun untuk transaksi. Setiap perubahan biaya transaksi akan diberitahukan kepada pengguna sesuai ketentuan peraturan yang berlaku.</p>
  </div>
</template>

<script>
export default {
  name: 'FAQ'
}
</script>

<style scoped>
@import "../../styles/markdown.css";
</style>
